export default __webpack_public_path__ + "static/slider.aktirol.klein-29a92f6bd2b3a0dc988740800e6b5a8b.png";